import { trackEvent } from "../utils/matomo";

const STREAM_SDK_SRC = "https://embed.cloudflarestream.com/embed/sdk.latest.js";
const PROGRESS_THRESHOLDS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

let streamSdkPromise = null;

// Cloudflare's Stream Player SDK exposes a global `Stream()` factory once
// loaded. It's loaded lazily (only once a video is actually opened) so we
// don't pay for it on every page load.
function loadStreamSdk() {
  if (window.Stream) return Promise.resolve(window.Stream);

  if (!streamSdkPromise) {
    streamSdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = STREAM_SDK_SRC;
      script.async = true;
      script.onload = () => resolve(window.Stream);
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  return streamSdkPromise;
}

export default function Videoplayer() {
  Alpine.data("videoplayer", () => ({
    get videoId() {
      return this.$store.videoPlayer.videoId;
    },

    _trackedThresholds: new Set(),

    init() {
      this.$watch("videoId", (val) => {
        document.body.style.overflow = val ? "hidden" : "";
        this._trackedThresholds = new Set();

        if (val) {
          this.$nextTick(() => this._initProgressTracking());
        }
      });
    },

    async _initProgressTracking() {
      const iframe = this.$refs.frame;
      if (!iframe) return;

      try {
        const Stream = await loadStreamSdk();
        const player = Stream(iframe);

        player.addEventListener("timeupdate", () => {
          if (!player.duration) return;

          const percent = (player.currentTime / player.duration) * 100;
          const headline = this.$store.videoPlayer.headline;

          PROGRESS_THRESHOLDS.forEach((threshold) => {
            if (
              percent >= threshold &&
              !this._trackedThresholds.has(threshold)
            ) {
              this._trackedThresholds.add(threshold);
              trackEvent("Video", `Progress ${threshold}%`, headline);
            }
          });
        });
      } catch (e) {
        // Stream SDK failed to load/init — progress tracking is best-effort,
        // playback itself doesn't depend on it.
      }
    },

    close() {
      this.$store.videoPlayer.close();
    },
  }));

  Alpine.data("videoplayertrigger", () => ({
    open(id, headline) {
      trackEvent("Video", "Play", headline);
      this.$store.videoPlayer.open(id, headline);
    },
  }));
}
